/* eslint-disable array-callback-return */
import CircleIcon from "@mui/icons-material/Circle";
import CloseIcon from "@mui/icons-material/Close";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import {
  Box,
  Button, CircularProgress, Container,
  Dialog,
  Drawer,
  Grid,
  Hidden,
  IconButton,
  Typography
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import html2canvas from 'html2canvas';
import moment from "moment-timezone";
import React from "react";
import QRCode from "react-qr-code";
import { useHistory, useLocation } from "react-router-dom";
import { TextBox } from "../../components";
import { config } from "../../config";
import { AlertContext, BackdropContext } from "../../contexts";
import { CANCEL_WORKER_PASS } from "../../graphql/queries";
import { NetworkCall } from "../../networkcall/index";
import { Routes } from "../../router/routes";
import { AlertProps, NetWorkCallMethods, enumSelect, enumCatagory, FontFamilySwitch } from "../../utils";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { withNamespaces } from "react-i18next";
import { withBottombar } from "../../HOCs";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#F6F6F6",
    padding: "0px",
  },
  rootCard: {
    backgroundColor: "white",
    borderRadius: "4px",
    boxShadow: "0px 3px 16px #F2F5FA",
  },
  img: {
    borderRadius: "4px",
    border: "1px solid #E4E8EE",
    padding: "2px 8px",
  },
  bottomBarTitle: {
    fontSize: "1.125rem",
    fontFamily: FontFamilySwitch().extraBold,
    color: theme.typography.color.primary,
  },
  title: {
    fontSize: "1rem",
    fontFamily: FontFamilySwitch().bold,
    color: theme.typography.color.secondary,
  },
  sub: {
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().semiBold,
    color: theme.typography.color.Tertiary,
  },
  approved: {
    fontSize: "0.75rem",
    color: "#FFFFFF",
    fontFamily: FontFamilySwitch().bold,
    background: "#5AC782",
    padding: "1px 8px",
    borderRadius: "4px",
    display: "inline",
  },
  progress: {
    fontSize: "0.75rem",
    color: "#FFFFFF",
    fontFamily: FontFamilySwitch().bold,
    background: "#78B1FE",
    padding: "1px 8px",
    borderRadius: "4px",
    display: "inline",
  },

  delete: {
    fontSize: "0.75rem",
    color: "#FFFFFF",
    fontFamily: FontFamilySwitch().bold,
    background: "red",
    padding: "1px 8px",
    borderRadius: "4px",
    display: "inline",
  },
  round: {
    color: "#F2F5FA",
    fontSize: "40px",
  },
  border: {
    border: "1px solid #E4E8EE",
    marginTop: "-4px",
    backgroundColor: "#E4E8EE",
  },
  heading: {
    fontSize: "0.75rem",
    color: theme.typography.color.Tertiary,
    fontFamily: FontFamilySwitch().semiBold,
    marginTop: "10px",
  },
  name: {
    fontSize: "1rem",
    color: theme.typography.color.primary,
    fontFamily: FontFamilySwitch().semiBold,
  },
  drawer: {
    "& .MuiDrawer-paper": {
      borderTopRightRadius: "4px",
      borderTopLeftRadius: "4px",
    },
    "& .MuiContainer-root": {
      padding: "0px 8px",
    },
  },
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: "4px",
      padding: "0px",
    },
  },
  titleroot: {
    borderBottom: "1px solid #c1c1c1",
    padding: "4px 8px 8px 8px",
  },

  cancelbtn: {
    padding: "12px",
    border: "1px solid #5078E1",
    backgroundColor: "white",
    borderRadius: "4px",
    textTransform:"capitalize"
  },
  submitbtn: {
    borderRadius: "4px",
    padding: "12px 8px",
    textTransform:"capitalize"

  },

  qr: {
    fontSize: "0.75rem",
    color: theme.palette.success.dark,
    fontFamily: FontFamilySwitch().bold,
    margin: "0px 12px"
  },
  expire: {
    fontSize: "0.75rem",
    color: theme.palette.success.dark,
    fontFamily: FontFamilySwitch().semiBold,
  },
  response: {
    backgroundColor: "#FFECEC",
    color: "#FF4B4B",
    textAlign: "center",
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().semiBold,
  },
  propertyname: {
    color: "#78B1FE",
    marginInlineStart: "10px",
    fontFamily: FontFamilySwitch().bold,
    fontSize: "0.875rem"

  }
}));
const InitialState = {
  remarks: "",
  error: {
    remarks: "",
  },
};
const ParkingDetails = ({ t = () => false, handleTopBarState }) => {
  const size = useWindowDimensions();
  const app = config?.app_x_build === "PG-TE-08" ? "Tenant2" : "Tenant"

  const history = useHistory();
  const searchURL = useLocation().search;
  const classes = useStyles();
  const alert = React.useContext(AlertContext);
  const [details, setDetails] = React.useState([]);
  const passId = new URLSearchParams(searchURL).get("passId");
  const [canceldata, setCancelData] = React.useState({ ...InitialState });
  const [cancel, setCancel] = React.useState(false);
  const backdrop = React.useContext(BackdropContext);
  const [downlodeload, setDownloeload] = React.useState(false)
  const logo = JSON.parse(localStorage.getItem("accessType"))?.filter((val) => val?.name === app)?.find((item) => item?.company_logo !== null)
  const clientLogo = localStorage.getItem("clientLogo")
  const [enumValue, setenumValue] = React.useState({
    status: {},
    type: {}
  });
  const getPassDetails = () => {
    const data = {
      tenantId: `${config.tenantid}`,
      request_id: passId,
    };
    NetworkCall(
      `${config.api_url}/security/request`,
      NetWorkCallMethods.post,
      data,
      null,
      true,
      false
    )
      .then((response) => {
        setDetails(response.data.data[0]);
        backdrop.setBackDrop({ ...backdrop, open: false });
      })
      .catch((err) => {
        alert.setSnack({
          ...alert,
          open: true,
          severity: AlertProps.severity.error,
          msg: t("SomethingWentwrong"),
        });
      });
  };
  React.useEffect(() => {
    handleTopBarState({
      text: "View Parking Slot Requset"
    })
    backdrop.setBackDrop({
      ...backdrop,
      open: true,
      message: "",
    });
    getPassDetails();
    getEnum()
    // eslint-disable-next-line
  }, []);
  const getEnum = async (data) => {
    const result = await enumSelect([enumCatagory?.security_status_enum_type, enumCatagory?.security_request_type])
    let requestSourceMap = result?.security_request_type.map((item, index) => {
      return {
        [`type${index + 1}`]: item?.value
      }
    })

    let requestType = Object.keys(requestSourceMap).map(key => requestSourceMap[key]).reduce((old, item) => (
      { ...old, ...item }
    ), {})

    let requestSourceMapStatus = result?.security_status_enum_type.map((item, index) => {
      return {
        [`type${index + 1}`]: item?.value
      }
    })

    let requestTypeStatus = Object.keys(requestSourceMapStatus).map(key => requestSourceMapStatus[key]).reduce((old, item) => (
      { ...old, ...item }
    ), {})


    setenumValue({ ...enumValue, status: requestTypeStatus, type: requestType })
  }
  const updateState = (key, value) => {
    let error = canceldata.error;
    error[key] = "";
    setCancelData({ ...canceldata, [key]: value, error });
  };
  const isIamValideTostep = () => {
    let isValid = true;
    let error = canceldata.error;
    //Checking Pass Type
    if (canceldata.remarks.length === 0) {
      isValid = false;
      error.remarks = t("RemarksisRequired");
    }

    setCancel({ ...canceldata, error });
    return isValid;
  };
  const cancelPass = () => {
    if (isIamValideTostep()) {
      const data = {
        query: CANCEL_WORKER_PASS,
        variables: {
          Id: passId,
          data: {
            status: "Cancelled",
            cancel_remarks: canceldata?.remarks,
          },
        },
      };
      NetworkCall(
        `${config.graphql_url}`,
        NetWorkCallMethods.post,
        data,
        null,
        true,
        false
      )
        .then((response) => {
          getPassDetails();
          setCancel(false);
        })
        .catch((err) => {
          alert.setSnack({
            ...alert,
            open: true,
            severity: AlertProps.severity.error,
            msg: t("SomethingWentwrong"),
          });
        });
    } else {
      return false;
    }
  };
  const renderForm = () => {
    return (
      <div style={{ padding: "12px" }}>
        <Box display="flex" alignItems="center" className={classes.titleroot}>
          <Box flexGrow={1}>
            <Typography variant="subtitle2" className={classes.bottomBarTitle}>
              {t("CancelParking")}
            </Typography>
          </Box>
          <Box>
            <IconButton size="small" onClick={() => setCancel(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Box height="12px" />
        <TextBox
          color
          label={t("Remarks")}
          placeholder={t("EnterRemarks")}
          value={canceldata.remarks}
          multiline
          onChange={(value) => updateState("remarks", value.target.value)}
          isError={canceldata?.error?.remarks?.length > 0}
          errorMessage={canceldata?.error?.remarks}
        />
        <Box height="12px" />
        <Button
          fullWidth
          className={classes.submitbtn}
          variant="contained"
          onClick={cancelPass}
        >
          {t("Submit")}
        </Button>
      </div>
    );
  };
  const downloadTicket = async (element) => {
    setDownloeload(true)
    const node = document.getElementById("ticket");
    // useCors to draw image from different origin
    html2canvas(node, { useCORS: true }).then((canvas) => {
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.download = `${element}.png`;
      a.href = canvas.toDataURL();
      a.click();
      setDownloeload(false)
    });
  }
  return (
    <Container className={classes.root} maxWidth="sm" sx={{ padding: "0px" }}>
      {/* <TitleBar
        text="View Parking Slot Requset"

        goBack={() => history.goBack()}
      /> */}
      <Grid
        container
        className={classes.screenScrollEffect}
        style={{
          height:
            details?.status ==="Pending"
              ? size?.height - 135
              : size?.height - 60,
          overflow: "scroll",
        }}
      >
        <Grid item xs={12} sx={{ padding: "12px 6px 12px 12px" }} id="ticket">
          <div className={classes.rootCard}>
            {details?.status ===  "Approved" && (
              <>
                <br />
                <center>
                  <div style={{ marginBottom: "8px" }}>
                    <img src={logo?.company_logo ?? clientLogo} alt="" style={{ height: "30px" }} />
                  </div>
                  <QRCode value={`${details?.qr_no}`} size={220} />
                </center>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "14px" }} >
                  <Box display="flex" alignItems="center" bgcolor={"#E8F9E8"} style={{ borderRadius: "4px" }}>
                    <Box style={{ overflow: "hidden" }}>
                      <CircleIcon
                        style={{ marginLeft: "-7px", marginTop: "8px", fontSize: "1rem", color: "white" }}
                      />
                    </Box>
                    <Box flexGrow={1} padding={"8px 36px"}>
                      <Typography className={classes.qr}>
                        {t("Passcode")}: {details?.qr_no}
                      </Typography>
                      <Typography variant="subtitle2" className={classes.expire}>
                        {t("ValidTill")}&nbsp;
                        &#x202a;{moment(details?.request_to)
                          .tz(moment.tz.guess())
                          .format("DD MMM YY, hh:mm a ")}&#x202c;
                      </Typography>
                    </Box>
                    <Box style={{ overflow: "hidden" }}>
                      <CircleIcon
                        style={{ marginRight: "-7px", marginTop: "8px", fontSize: "1rem", color: "white" }}
                      />
                    </Box>
                  </Box>
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "20px" }} >
                  <div style={{ backgroundColor: "#F1F7FF", padding: "8px 16px", borderRadius: "8px" }}>
                    <img src="/images/icons8-city.svg" alt="city" />
                    <span className={classes.propertyname}>{details?.property_name}</span>
                  </div>
                </div>
                <Box display="flex" alignItems="center">
                  <Box style={{ overflow: "hidden" }}>
                    <CircleIcon
                      className={classes.round}
                      style={{ marginLeft: "-20px" }}
                    />
                  </Box>
                  <Box flexGrow={1}>
                    <Box className={classes.border} />
                  </Box>
                  <Box style={{ overflow: "hidden" }}>
                    <CircleIcon
                      className={classes.round}
                      style={{ marginRight: "-20px" }}
                    />
                  </Box>
                </Box>
                <Box display="flex" alignItems="center" p={3} marginTop="-24px">
                  <Box className={classes.img}>
                    <img
                      src="/images/parkingslot.svg"
                      alt=""
                      style={{ objectFit: "contain", marginTop: "4px" }}
                    />
                  </Box>
                  <Box flexGrow={1} sx={{ marginInlineStart: "10px" }}>
                    <Typography variant="subtitle2" className={classes.title}>
                      {details?.request_type === "PSR" &&
                        t("Parking Slot Requirement")}
                    </Typography>
                    <Typography variant="subtitle2" className={classes.sub}>
                      {t("Requestedon")}{" "}
                      &#x202a;{moment(details?.request_from)
                        .tz(moment.tz.guess())
                        .format("DD MMM")}&#x202c;
                    </Typography>
                    {details?.status ===  "Pending" && (
                      <Typography
                        variant="subtitle2"
                        noWrap
                        className={classes.progress}
                      >
                        {t("InProgress")}
                      </Typography>
                    )}
                    {details?.status === "Approved" && (
                      <Typography variant="subtitle2" className={classes.approved}>
                        {t("Approved")}
                      </Typography>
                    )}
                    {details?.status === "Rejected" && (
                      <Typography variant="subtitle2" className={classes.delete}>
                        {t("Rejected")}
                      </Typography>
                    )}
                    {details?.status === "Cancelled" && (
                      <Typography variant="subtitle2" className={classes.delete}>
                        {t("Cancelled")}
                      </Typography>
                    )}
                  </Box>
                  <Box>
                    {details?.status !== "Rejected" && (
                      <>
                        {details?.status ===  "Approved" ? (
                          <>
                            {
                              downlodeload ?
                                <CircularProgress />
                                :
                                <IconButton
                                  onClick={() => downloadTicket(details?.request_type)}
                                >
                                  <DownloadOutlinedIcon color="primary" />
                                </IconButton>
                            }
                          </>
                        ) : (
                          <IconButton
                            onClick={() =>
                              history.push(
                                Routes.createParking + "?passId=" + details?.id
                              )
                            }
                          >
                            <img
                              src="/images/Outline.svg"
                              alt=""
                              style={{ objectFit: "contain", marginTop: "4px" }}
                            />
                          </IconButton>
                        )}
                      </>
                    )}
                  </Box>
                </Box>
                {details?.status === "Received At Gate" && (
                  <Box
                    className={classes.response}
                    style={{ padding: "4px", marginBottom: "26px" }}
                  >
                    <Typography className={classes.response}>
                      {t("Collectfrom")} {details?.gate}
                    </Typography>
                  </Box>
                )}
                <Box flexGrow={1} margin="0px 20px">
                  <Box className={classes.border} />
                </Box>
              </>
            )}
            {details?.status !==  "Approved" && (
              <>
                <Box display="flex" alignItems="center" p={3}>
                  <Box className={classes.img}>
                    <img
                      src="/images/parkingslot.svg"
                      alt=""
                      style={{ objectFit: "contain", marginTop: "4px" }}
                    />
                  </Box>
                  <Box flexGrow={1} sx={{ marginInlineStart: "10px" }}>
                    <Typography variant="subtitle2" className={classes.title}>
                      {details?.request_type === "PSR" &&
                        t("Parking Slot Requirement")}
                    </Typography>
                    <Typography variant="subtitle2" className={classes.sub}>
                      {t("Requestedon")}{" "}
                      &#x202a;{moment(details?.request_from)
                        .tz(moment.tz.guess())
                        .format("DD MMM")}&#x202c;
                    </Typography>

                    {details?.status === "Pending" && (
                      <Typography
                        variant="subtitle2"
                        noWrap
                        className={classes.progress}
                      >
                        {t("InProgress")}
                      </Typography>
                    )}
                    {details?.status ===  "Approved" && (
                      <Typography variant="subtitle2" className={classes.approved}>
                        {t("Approved")}
                      </Typography>
                    )}
                    {details?.status === "Rejected" && (
                      <Typography variant="subtitle2" className={classes.delete}>
                        {t("Rejected")}
                      </Typography>
                    )}
                    {details?.status === "Cancelled" && (
                      <Typography variant="subtitle2" className={classes.delete}>
                        {t("Cancelled")}
                      </Typography>
                    )}
                  </Box>
                  <Box>
                    {details?.status !== "Cancelled" && (
                      <>
                      
                        {details?.status ===  "Approved" ? (
                          <>
                            {
                              downlodeload ?
                                <CircularProgress />
                                :
                                <IconButton
                                  onClick={() => downloadTicket(details?.request_type)}
                                >
                                  <DownloadOutlinedIcon color="primary" />
                                </IconButton>
                            }
                          </>
                        ) : (
                          <IconButton
                            onClick={() =>
                              history.push(
                                Routes.createParking + "?passId=" + details?.id
                              )
                            }
                          >
                            <img
                              src="/images/Outline.svg"
                              alt=""
                              style={{ objectFit: "contain", marginTop: "4px" }}
                            />
                          </IconButton>
                        )}
                      </>
                    )}
                  </Box>
                </Box>
                {details?.status === "Received At Gate" && (
                  <Box
                    className={classes.response}
                    style={{ padding: "4px", marginBottom: "26px" }}
                  >
                    <Typography className={classes.response}>
                      {t("Collectfrom")} {details?.gate}
                    </Typography>
                  </Box>
                )}

                <Box display="flex" alignItems="center" marginTop="-20px">
                  <Box style={{ overflow: "hidden" }}>
                    <CircleIcon
                      className={classes.round}
                      style={{ marginLeft: "-20px" }}
                    />
                  </Box>
                  <Box flexGrow={1}>
                    <Box className={classes.border} />
                  </Box>
                  <Box style={{ overflow: "hidden" }}>
                    <CircleIcon
                      className={classes.round}
                      style={{ marginRight: "-20px" }}
                    />
                  </Box>
                </Box>
              </>
            )}
            <Box p={3} marginTop="-24px">
              <Grid container>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" className={classes.heading}>
                    {t("REFERENCEID")}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.title}>
                    {details?.request_no}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.heading}>
                    {t("VEHICLETYPE")}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.title}>
                    {details?.vechicle_type}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.heading}>
                    {t("GATEENTRY")}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.title}>
                    {details?.gate}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="subtitle2" className={classes.heading}>
                    {t("UNIT")}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.title}>
                    {details?.unit?.[0]?.name}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.heading}>
                    {t("VEHICLENUMBER")}
                  </Typography>
                  <Typography variant="subtitle2" className={classes.title}>
                    {details?.vechicle_number}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" className={classes.heading}>
                    {t("VISITSTARTandENDDATE")}
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    className={classes.title}
                    noWrap
                  >
                    &#x202a;{moment(details?.request_from)
                      .tz(moment.tz.guess())
                      .format("DD MMM YY hh:mm a")}&#x202c;
                    &nbsp;-&nbsp;
                    &#x202a;{moment(details?.request_to)
                      .tz(moment.tz.guess())
                      .format("DD MMM YY hh:mm a")}&#x202c;
                  </Typography>
                </Grid>
                {details?.status ===  "Approved" && (
                  <>
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"
                        className={classes.heading}
                      >
                        {t("CHECKINBY")}
                      </Typography>
                      <Typography variant="subtitle2" className={classes.title}>
                        {details?.parking_check_in_by ? (
                          <>
                            {details?.parking_check_in_by}&nbsp;-&nbsp;
                            {details?.actual_in && (
                              <>
                                {moment(details?.actual_in)
                                  .tz(moment.tz.guess())
                                  .format("DD MMM YY hh:mm a")}
                              </>
                            )}
                          </>
                        ) : (
                          t("YetToCheckIn")
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle2"
                        className={classes.heading}
                      >
                        {t("CHECKOUTBY")}
                      </Typography>
                      <Typography variant="subtitle2" className={classes.title}>
                        {details?.parking_check_out_by ? (
                          <>
                            {details?.parking_check_out_by}&nbsp;-&nbsp;
                            {details?.actual_out && (
                              <>
                                {moment(details?.actual_out)
                                  .tz(moment.tz.guess())
                                  .format("DD MMM YY hh:mm a")}
                              </>
                            )}
                          </>
                        ) : (
                          t("YetToCheckOut")
                        )}
                      </Typography>
                    </Grid>
                  </>
                )}
              </Grid>
              <br />
            </Box>
          </div>
        </Grid>
      </Grid>
      {details?.status === "Pending" && (
        <div
          style={{
            padding: "12px",
            backgroundColor: "white",
            boxShadow: "0px -1px 6px #00000021",
          }}
        >
          <Button
            fullWidth
            className={classes.cancelbtn}
            onClick={() => setCancel(true)}
          >
            {t("CancelService")}
          </Button>
        </div>
      )}
      <Hidden smDown>
        <Dialog
          className={classes.dialog}
          maxWidth="sm"
          fullWidth
          open={cancel}
          onClose={() => setCancel(false)}
        >
          {renderForm()}
        </Dialog>
      </Hidden>
      <Hidden smUp>
        <Drawer
          className={classes.drawer1}
          anchor="bottom"
          open={cancel}
          onClose={() => setCancel(false)}
        >
          {renderForm()}
        </Drawer>
      </Hidden>
    </Container>
  );
};

const props = {
  top_bar: "title_bar",
}

export default withBottombar(withNamespaces("parkingpass")(ParkingDetails), props)